<script>
	import { flyParams, pageState, steps, bq } from '../store';
	import GbmInput from '../components/GbmInput.svelte';
	import { fly } from 'svelte/transition';
	import { locale, t } from '$lib/locales';
	import { page } from '$app/stores';
	import { onMount } from 'svelte';

	let ready = false;

	onMount(async () => {
		ready = true;
	});
</script>

{#if ready}
	<div
		data-cy="steps-layout"
		class="content"
		in:fly|local={flyParams.in}
		out:fly|local={flyParams.out}
	>
		<p data-cy="steps">
			{$t('gbm.step_out_of', { step: $page.data.step })}
			<span style:font-weight="700">
				{$t(`gbm.steps.${$page.data.step}`)}
			</span>
		</p>
		{#if $page.data.step === steps.party_size || $page.data.step === steps.more_info}
			<p
				data-cy="booking-description"
				class="date-title"
				style={$pageState.md ? 'font-size: 14px' : ''}
			>
				{$t('gbm.confirm_party_size', {
					date: $bq.date.toLocaleDateString($locale, {
						year: 'numeric',
						month: '2-digit',
						day: 'numeric'
					}),
					time: $bq.time,
					adults: $bq.nbPersons || 0,
					children: $bq.nbChildren || 0
				})}
			</p>
		{/if}
		<div style:display="grid" style:margin="20px 0">
			<slot />
		</div>
		<div class="button-container">
			{#if $page.data.step !== steps.date}
				<GbmInput cy="back-button" type="button" on:click={$pageState.back}>
					<span class="button-content" style="width: 100%">
						<div class="arrow" />
						{$t('shared.back')}
					</span>
				</GbmInput>
			{/if}
			{#if $page.data.step === steps.party_size}
				<GbmInput
					style={'width: clamp(50px, 100%, 100px);'}
					cy="next-button"
					type="button"
					on:click={$pageState.triggerStepAction}
				>
					<span class="button-content" style="width: 100%; justify-content: center;">
						{$t('shared.ok')}
					</span>
				</GbmInput>
			{/if}
		</div>
	</div>
{/if}

<style>
	.date-title {
		font-size: 18px;
		font-weight: 600;
	}
	.content {
		grid-row: 1/2;
		grid-column: 1/2;
		max-width: 100vw;
	}
	.button-container {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 1rem;
		gap: 20px;
	}
	.button-content {
		display: flex;
		gap: 5px;
		align-items: center;
	}
	p {
		color: var(--font-color);
		text-align: center;
		font-size: 16px;
		margin: 0.3em 0;
	}
	span::first-letter {
		text-transform: uppercase;
	}

	.arrow {
		background: var(--font-color);
		height: 1px;
		width: 20px;
		margin: 0 auto;
		position: relative;
		cursor: pointer;
		transition: 0.2s ease;
	}
	.arrow:before,
	.arrow:after {
		content: '';
		background: var(--font-color);
		position: absolute;
		height: 1px;
		width: 12px;
		transition: 0.2s ease;
	}
	.arrow:before {
		left: -2px;
		bottom: -4px;
		transform: rotate(45deg);
	}
	.arrow:after {
		left: -2px;
		top: -4px;
		transform: rotate(-45deg);
	}
</style>
